import * as actionTypes from "./types";

export const listProductsForSuggestions = (establishmentId) => ({
  type: actionTypes.PRODUCT_SUGG_PRODUCTS,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/product/products-for-suggestions.json`,
    method: "GET",
    params: { establishment: establishmentId },
  },
  payload: {},
});

export const listSuggestions = (productId) => ({
  type: actionTypes.PRODUCT_SUGG_LIST,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/product/${productId}/suggestions.json`,
    method: "GET",
  },
  payload: {},
});

export const listIngredients = (productId) => ({
  type: actionTypes.PRODUCT_SUGG_INGREDIENTS,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/product/${productId}/ingredients.json`,
    method: "GET",
  },
  payload: {},
});

export const listPictos = () => ({
  type: actionTypes.PRODUCT_SUGG_PICTOS,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/product/pictos.json`,
    method: "GET",
  },
  payload: {},
});

export const createSuggestion = (productId, params) => ({
  type: actionTypes.PRODUCT_SUGG_CREATE,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/product/${productId}/suggestions.json`,
    method: "POST",
    body: params,
  },
  payload: {},
});

export const updateSuggestion = (id, params) => ({
  type: actionTypes.PRODUCT_SUGG_UPDATE,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/product/suggestion/${id}.json`,
    method: "PUT",
    body: params,
  },
  payload: { id },
});

export const deleteSuggestion = (id) => ({
  type: actionTypes.PRODUCT_SUGG_DELETE,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/product/suggestion/${id}.json`,
    method: "DELETE",
    body: {},
  },
  payload: { id },
});
